module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-23.6b0acbff.svg";